<template>
  <nav class="sidenav" role="navigation">
    <div class="navbar-section">
      <a class="navbar-link is-arrowless" href="#">
        NFD Academy
      </a>
      <div class="" v-if="true || activeSection == 'nfd-academy'">
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['nft-101'].includes(this.$route.name) }" href="/nfd-academy/nft-101">NFT 101</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['glossary'].includes(this.$route.name) }" href="/nfd-academy/glossary">Glossary</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['web3-workshops'].includes(this.$route.name) }" href="/nfd-academy/web3-workshops">Web3 Workshops</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['scholarship'].includes(this.$route.name) }" href="/nfd-academy/scholarship">Scholarship</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['philanthropic'].includes(this.$route.name) }" href="/nfd-academy/philanthropic">Philanthropic</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['security-and-safety'].includes(this.$route.name) }" href="/nfd-academy/security-and-safety">Security and Safety</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['mental-health'].includes(this.$route.name) }" href="/nfd-academy/mental-health">Mental Health</a>
      </div>
    </div>

    <div class="navbar-section">
      <a class="navbar-link is-arrowless" href="#">
        Events/Metaverse
      </a>
      <div class="" v-if="true || activeSection == 'events'">
         <a class="navbar-sub-item" href="https://www.cryptovoxels.com/parcels/6270" target="_blank">Visit CV</a>
         <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['workshop-signup'].includes(this.$route.name) }" href="/events/workshop-signup">Workshop Sign Ups</a>
         <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['meta-music-hall'].includes(this.$route.name) }" href="/events/meta-music-hall">Meta Music Hall</a>
         <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['twitter-spaces'].includes(this.$route.name) }" href="/events/twitter-spaces">Twitter Spaces</a>
         <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['community-spotlight'].includes(this.$route.name) }" href="/events/community-spotlight">Community Spotlight</a>
         <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['fathers-day-5k'].includes(this.$route.name) }" href="/events/fathers-day-5k">Fathers Day 5k Plus</a>
         <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['past-events'].includes(this.$route.name) }" href="/events/past-events">Past Events</a>
      </div>
    </div>

    <div class="navbar-section">
      <a class="navbar-link is-arrowless" href="#">
        The Project
      </a>
      <div class="" v-if="true || activeSection == 'token'">
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['mint'].includes(this.$route.name) }" href="/token/mint">Mint</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['roadmap'].includes(this.$route.name) }" href="/token/roadmap">Roadmap</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['faq'].includes(this.$route.name) }" href="/token/faq">FAQ</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['merch'].includes(this.$route.name) }" href="/token/merch">Merch Store</a>
      </div>
    </div>

    <div class="navbar-section">
      <a class="navbar-link is-arrowless" href="#">
        Utility
      </a>
      <div class="" v-if="true || activeSection == 'utility'">
        <a class="navbar-sub-item" href="#">Skinned games</a>
        <a class="navbar-sub-item" href="#">NFD Academy (Advanced)</a>
        <a class="navbar-sub-item" href="#">Web 3 Workshops</a>
        <a class="navbar-sub-item" href="#">Ask A Question!</a>
        <a class="navbar-sub-item" href="#">MarketPlace</a>
        <a class="navbar-sub-item" href="#">Newsletter</a>
        <a class="navbar-sub-item" href="#">Exclusive Merch</a>
        <a class="navbar-sub-item" href="#">Gallery</a>
      </div>
    </div>

    <div class="navbar-section">
      <a class="navbar-link is-arrowless" href="#" v-bind:class="{ 'highlight': ['/team/about', '/team/our-y', '/team/socials', '/team/portfolio', '/team/partners', '/team/contact'].includes(this.$route.path) }">
        Team
      </a>
      <div class="" v-if="true || activeSection == 'team'">
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['about'].includes(this.$route.name) }" href="/team/about">About Us</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['our-y'].includes(this.$route.name) }" href="/team/our-y">Our Y</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['socials'].includes(this.$route.name) }" href="/team/socials">Socials</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['portfolio'].includes(this.$route.name) }" href="/team/portfolio">NFT Portfolio</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['partners'].includes(this.$route.name) }" href="/team/partners">Partners</a>
        <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['contact'].includes(this.$route.name) }" href="/team/contact">Contact</a>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "SideNav",
  data() {
    return {
      activeSection: ''
    };
  },
  mounted() {}
};
</script>
<style scoped>
.sidenav {
  padding-top: 10px;
}
.navbar-link {
  display: block;
  color: #485fc7;
}
.navbar-link.highlight{
  font-weight: bold;
}
.navbar-sub-item {
  display: block;
  padding: 0 0 0 25px;
  font-weight: normal;
  font-size: 14px;
  color: #666;
}
  .navbar-sub-item:hover {
    text-decoration: underline;
  }
.navbar-sub-item.highlight {
  color: #000;
}
</style>